import { render, staticRenderFns } from "./ChatFooter.vue?vue&type=template&id=6abc266c"
import script from "./ChatFooter.vue?vue&type=script&lang=js"
export * from "./ChatFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports